module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-008"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h2', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("2")])]), _c('h2', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Keep Watch, Dear Lord")])]), _c('h2', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_vm._v("Pain and Presence")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WAS A CHILD")]), _vm._v(",")]), _vm._v(" I was afraid of what lurks in the dark—monsters in the closet, ghostly sounds of branches scratching the roof, bad guys just beyond the door.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Back then, I could bolt from my bed and wedge myself between my sleeping mom and dad. But now that I’m the grown up with my own five-year-old who squirms her way into our bed each night, where is my safe place? Imagined monsters in the closet seem easier to hide from than the fear of cancer or the throb of disappointment or the loss of a job or the hard conversations that I replay in my mind or my uncertainty about how to parent my kids or live life well or trust God.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The band Over the Rhine has a song that asks, “Who will guard the door when I am sleeping?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-024",
      "id": "ap_ntf-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Each night I ask that question. Is anyone watching out for me?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What does it mean for God to keep watch with us?")]), _c('p', {
    staticClass: "sep"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/sep_autre.jpg"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Amid thousands of forgotten sermons in my life, there is one sentence in one sermon that I’ll never forget.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("It was a gray Sunday morning when I was in college. A few months before, a three-year-old boy in our congregation had drowned. Our church was still staggered in grief as I sat listening to my pastor, Hunter, preach about trusting God. “You cannot trust God to keep bad things from happening to you,” he said. I was dumbstruck.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What Hunter said is self-evident. Bad things happen all the time, and I knew that then as I do now. But what he said was also devastating. In some wordless place deep within, I had hoped that God would keep bad things from happening to me—that it was somehow his job to do so, that he owed me that much. The plain truth of what Hunter said stood before me, obvious and terrible.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Of course, God does keep many bad things from happening to us. We do not know all the unnoticed ways we’ve been spared some misery—the accidents we weren’t in, the injuries we just avoided, the destructive relationships we never began, the diseases our white blood cells silently snuffed from our bodies unbeknownst to us.")]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('i', [_vm._v("But if God cannot be trusted to keep bad things from happening to us, how can he be trusted at all?")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But Hunter’s point was that God does not keep all bad things from happening to us. He cannot be trusted to do that because he never made that promise. Doing so is, apparently, not his job. Our Creator lets us remain vulnerable.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But if God cannot be trusted to keep bad things from happening to us, how can he be trusted at all?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This was the question that I couldn’t shake, the question that haunted the empty silence of the night.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In 2017, after months of talk about grief and loss, about my parents and my marriage, about body trauma and depression, about nighttime and “comfort activities,” my counselor looked at me and asked, “Where is God in all of this?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("Could I believe that God cares about me when he doesn’t stop bad things from happening? Could I trust him when I’m terrified that he will let me, or those I love, hurt? When I look across the immense collective sadness of the world, can I still know God as kind or loving? Is anyone looking out for us? Is anyone keeping watch?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The theological struggle I was facing has a long history and a name: theodicy.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Theodicy names the abstract “problem of pain”—the logical dilemma of how God can be good and all-powerful even as horrible things regularly happen in the world. And it also names the crisis of faith that often comes from an encounter with suffering."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-025",
      "id": "ap_ntf-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This wasn’t the first time that I’d wrestled with theodicy. But our difficult year—and perhaps simply growing older—made unresolved questions return with a vengeance and howl through the long, dark night.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Theodicy is not merely a cold philosophical conundrum. It is the engine of our grimmest doubts. It can sometimes wither belief altogether. A recent survey showed that the most commonly stated reason for unbelief among Millennials and Gen Z-ers was that they “have a hard time believing that a good God would allow so much evil or suffering in the world.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This is an increasingly common struggle. More young people voice frustration and confusion about theodicy now than in the last several generations."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-026",
      "id": "ap_ntf-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Many of those who walk into agnosticism or atheism do so not out of any reasoned proof (since there is no irrefutable proof for or against God’s existence) but out of a deep sense that, if there is a God, he (or she or it) cannot be trusted. This is unbelief as protest."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-027",
      "id": "ap_ntf-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" In Samuel Beckett’s play "), _c('i', [_vm._v("Endgame")]), _vm._v(", his character Hamm rejects the existence of God with the quip, “The bastard! He doesn’t exist!”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-028",
      "id": "ap_ntf-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If there is no God, the problem of pain vanishes. In his book "), _c('i', [_vm._v("Unapologetic")]), _vm._v(", Francis Spufford points out that “in the absence "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("of God, of course, there’s still pain. But there’s no problem. It’s just what happens.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-029",
      "id": "ap_ntf-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" But, he says,")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Once the God of everything is there in the picture, and the physics and biology and history of the world become in some ultimate sense His responsibility, the lack of love and protection in the order of things begins to shriek out. . . . The only easy way out of the problem is to discard the expectation that causes the problem, by ditching the author Himself."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-030",
      "id": "ap_ntf-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If there is no God of love, questions about theodicy evaporate, but so does any redemptive meaning our pain might have, any transcendent story in which we might situate our suffering. More importantly, when we dispose of the problem of pain in this way, we face the “problem of goodness.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-031",
      "id": "ap_ntf-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Philosopher Alasdair MacIntyre wrote that when we reject God to ease the tension that pain creates, goodness goes with it. To call something “good” without any overarching meaning is merely to say, “Hurrah for this!” or “I like this!,” which is well enough, but it disregards our deep intuition that true beauty, kindness, gentleness, and wonder participate in and point to a real and ultimate foundation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-032",
      "id": "ap_ntf-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If there is no one to keep watch with us, no one we can trust to look out for us in the night, then anything that happens, however good or bad, is sheer chaos, chance, and biological accident. But belief in a transcendent God means we are stuck with the problem of pain. So there are libraries of books seeking to answer the question of theodicy—responses and solutions offered by the hundreds, many of them very good and wise.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Yet despite all the ink spilled, we are not satisfied. Our questions persist.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Because ultimately theodicy is not a cosmic algebra equation, where we can simply solve for "), _c('i', [_vm._v("x")]), _vm._v(". It is almost primordial. A scream. An ache. A protest from the depths of the human heart."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-033",
      "id": "ap_ntf-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("Where are you, oh God? Is anyone watching out for us? Does anyone see? And tell us why! Why this evil, this heartbreak, this suffering?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I have come to see theodicy as an existential knife-fight between the reality of our own quaking vulnerability and our hope for a God who can be trusted.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At the end of the day—in my case, literally in the darkness of the night—the problem of theodicy cannot be answered. As Flannery O’Connor wrote, it is not “a problem to be solved, but a mystery to be endured.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-034",
      "id": "ap_ntf-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We sometimes talk about mystery as if it’s a code to crack—as if the full sweep of knowledge is available to us, but we just haven’t sussed it out yet. But true mystery invokes things that are fundamentally beyond our grasp. Mystery is an encounter with an unsearchable reality, an acknowledgement that the world crackles with possibility because it is steeped in the shocking and unpredictable presence of God. Avery Cardinal Dulles wrote that mysteries are “not fully intelligible to the finite mind,” but that the reason for this is “not the poverty but the richness” of the mystery."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-035",
      "id": "ap_ntf-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One reason the problem of suffering cannot be answered tidily is that pain and brokenness are, at their roots, antirational. Christians understand evil and suffering to be forces of “anti-creation.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-036",
      "id": "ap_ntf-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" They don’t fit in the realm of reason and order because they frustrate reason and disintegrate order. If there was a neat rationale for pain, it would necessarily fit somewhere in the order of the cosmos, an essential part of reality. But the early church’s understanding of suffering and evil was that they were an absurd and inexplicable abnormality, a gross absence of the good and true."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-037",
      "id": "ap_ntf-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But secondly, and much more importantly, the problem of pain can’t be adequately answered because we don’t primarily want "), _c('i', [_vm._v("an answer")]), _vm._v(". When all is said and done, we don’t want God to simply explain himself, to give an account of how hurricanes "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("or head colds fit into his overall redemptive plan. We want action. We want to see things made right."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-038",
      "id": "ap_ntf-038-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At its heart, theodicy is the longing for a God who notices our suffering, who cares enough to act, and who will make all things new. It is an ache that cannot be shaken, which we all share deep in our bones and carry with us every day—and every night.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In my favorite C. S. Lewis book, "), _c('i', [_vm._v("Till We Have Faces")]), _vm._v(", the protagonist Orual writes a complaint against the gods. We hear her stories of suffering: being born ugly, losing her mother as a young child, finding her truest friend and deepest love—her little sister—only to lose her. Grief after grief is spelled out in bitter detail.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Orual demands an answer. She demands that the gods vindicate themselves.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the final pages of the book, with her list of accusations still in hand, Orual meets God in a vision. She is transformed, and concludes her book with this: “I know now, Lord, why you utter no answer. You are yourself the answer. Before your face questions die away. What other answer would suffice? Only words, words; to be led out to battle against other words.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-039",
      "id": "ap_ntf-039-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In our deepest suffering, we do not simply want words to battle other words. We want things made right.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Christians have always known the reality of pain. They’ve lived through wars and plagues, without vaccines or modern medicine, when death was ever at the door, when suffering was rampant and unavoidable, when nights were horrifyingly dark. Yet, millions of the faithful have long held stubbornly to this antinomy: God is good and powerful, and terrible things regularly happen in the world.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The church has always known this paradox, but instead of resolving its tension, it has let it persist. We have left this chord humming in dissonance for thousands of years, always believing that it will only be resolved when God himself sounds the final consonant note.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("My deepest question, "), _c('i', [_vm._v("Where is God in all this?")]), _vm._v(", is an ache that I hope to endure until my longing meets its end. I want justice; I want resurrection; I want wholeness, wellness, and restoration. And I won’t be fully satisfied until God—before whose face our questions die away—sets every last thing right.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But we’re not there yet. We live in the meantime. And in this meantime, how can we endure such a mystery? How can we live as Christians in a world where children suffer, where marriages disintegrate, where injustice rages, where tyrants succeed, where we face frustration and futility, where we get sick, where we all eventually die? How do we trust a God who does not stop all this from happening? How do we dare ask him to keep watch?")]), _c('p', {
    staticClass: "sep"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/sep_autre.jpg"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As a pastor, I’ve come to see that in the most vulnerable and human moments of our lives, doctrine is unavoidable. When all else gives way, all of us, from atheists to monks, fall back on what we believe about the world, about ourselves, and about God.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My friend Julie (Hunter’s wife) is an artist. Her watercolors hang in my kitchen. Years ago, when her son was very young, he had to have surgery. Like any parents whose child is going under the knife, my friends were anxious. Before the nurses wheeled their infant son into the operating room, Julie looked at Hunter and said, “We have to decide right now whether or not God is good, because if we wait to determine that by the results of this surgery, we will always keep God on trial.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If the question of whether God is real or not—or of whether God is kind or indifferent or a bastard—is determined solely by the balance of joy and sorrow in our own lives or in the world, we will never be able to say anything about who God is or what God is like. The evidence is frankly inconclusive. If the story of my short life and feelings determine God’s character, then he is Jekyll and Hyde. This way of approaching God becomes "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("a never-ending game of poker. For every breathtaking splash of a whale’s breach, I raise you a forest fire obliterating acre after acre. For every monarch migration, I raise you ticks spreading Lyme disease. For every mother enraptured by her child’s first smile, there is another mother whose newborn struggles for his final breath. For every inspiring act of human goodness, there is another person scheming against the weak. In all our lives, from the happiest to the most tragic, the circumstantial evidence for God’s goodness is divided. There is beauty and there is horror.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We cannot hold together human vulnerability and God’s trustworthiness at the same time unless there is some certain sign that God loves us, that he isn’t an absentee landlord or, worse, a monster. But we cannot divine such a sign from the circumstances of our lives or of the world. We have to decide what we believe about who God is and what he is like. We have to decide if anyone keeps watch with us. It is unavoidably—even irritatingly—a decision based on doctrine, the first principles we return to again and again, the story we define our lives by.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Francis Spufford writes, “We don’t have an argument that solves the problem of the cruel world, but we have a story.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-040",
      "id": "ap_ntf-040-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" This is why, no matter what we claim to believe or disbelieve, what rises to the surface in our most vulnerable moments is inevitably the story on which we build our lives.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Christianity does not give us a concise explanation for vulnerability, loss, or pain, but it gives us a story—a real story in history. The "), _c('i', [_vm._v("Catechism of the Catholic Church")]), _vm._v(" states that, “There is not a single aspect of the Christian message that is not in part an answer to the question of evil [and human suffering].”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-041",
      "id": "ap_ntf-041-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" It takes the whole story of redemptive history to shape our questions about God’s presence in the darkness. There may be no tidy solution to the problem of pain, but this is not because these questions are unimportant or, in a final sense, unanswerable. If there is anything remotely approaching a Christian answer to our questions about theodicy, the story is the answer.")]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('i', [_vm._v("If there is anything remotely approaching a Christian answer to our questions about theodicy, the story is the answer.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("When Julie sat in a hospital waiting room as surgeons carved her son’s tender skin, she committed herself to deciding whether God could be trusted, regardless of the result of the surgery. She had to decide if she believed these claims that Christianity makes about God’s goodness. She quit the poker game, folded her cards, and decided to trust a God who did not guarantee that bad things would not happen to her or her son.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But this was not an arbitrary decision; not a leap in the dark. She was not simply ratcheting herself up to affirm the goodness of God in spite of contrary evidence. She did look to evidence, though not the evidence of her life, nor the tally of the total amount of good in the world versus the total amount of evil. Instead, she looked at the life of Jesus. It’s on this story that she anchored her decision about whether she would trust God, without knowing what would happen next.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The church has always proclaimed that if we want to see what God is like, we look at Jesus—a man “acquainted with sorrow” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Isaiah+53%3A3&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Isaiah 53:3")]), _vm._v("), no stranger to grief, a peasant craftsman who knew suffering, big and small, and died as a criminal, mostly alone.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Mysteriously, God does not take away our vulnerability. He enters into it.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Jesus left a place where there is no night to enter into our darkness. He met with blisters and indigestion, with fractured relationships and the death of friends, with an oppressive empire, the indignity of poverty, and the terror of violence. One night he sweat blood, asking the Father to spare him from agony, weeping in the lonely darkness while his friends fell asleep. He said, “Not my will, but yours, be done” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Luke+22%3A42&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Luke 22:42")]), _vm._v("), and soon afterward he was tortured to death.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("God did not keep bad things from happening to God himself.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To look to Jesus is to know that our Creator has felt pain, has known trouble, and is well-acquainted with sorrow. But our hope in suffering is not merely to gaze on the biography of an ancient man frozen in the pages of the Bible. The story of the gospel is not a mere mantra or a relic of history. It is alive and ongoing. The work of Jesus continues, even now, in our everyday lives. So in hardship we do not look to Jesus solely as one who has been there before, once upon a time in a distant past. We find he is here with us, in the present tense. He participates in our suffering, even as—mysteriously—in our suffering we participate in the fullness of Christ’s life.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But we cannot embrace the Christian story or Christ’s ongoing presence in our lives by an act of sheer will or an exercise in cognition. Our hope in sorrow is not something we carry around as a brute fact or, worse, a pat answer. I do not come to trust the Christian story in the same way I trust that Lake Superior is the largest of the Great Lakes or that bread is made of yeast and flour. The story we live by is one that we somehow enter into—we discover our own small lives and stories in the larger story of God and his church.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We do that through the practices and prayers we receive from those who have gone before us. We take up and learn the craft of faith that allows us to know an actual, surprising, frustrating, and relentlessly merciful God. In the present tense.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Years ago, during a vacation in New Hampshire, Jonathan and I climbed Mount Washington, which is notorious for erratic weather. It can change from sunny and warm to snowing in a few hours. The wind is so strong that it once held the record for the fastest wind gust on earth. On our hike, we thought we might be blown off the mountain (we have no photos from that day in which my hair is not blown entirely across my face). And then there’s the fog, which settles so deep and thick that hikers have gotten lost and died. So the good "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("people of New Hampshire have made cairns along the trail: massive, towering rock structures that plot the course. When the fog descends and the weather is dangerous, hikers can make it to shelter at the bottom of the mountain or at the top by walking from cairn to cairn in the white out.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In times of deep darkness, the cairns that have kept me in the way of Jesus were the prayers and practices of the church.")]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('i', [_vm._v("In times of deep darkness, the cairns that have kept me in the way of Jesus were the prayers and practices of the church.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When I could not pray, the church said, “Here are prayers.” When I could not believe, the church said, “Come to the table and be fed.” When I could not worship, the church sang over me the language of faith.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Inherited ways of prayer and worship—liturgical practices—are a way that the ancient church built cairns for us, to help us endure this mystery, to keep us on this path of faith, to guide us home.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Theodicy is in no way “solved” for me. It is not in fact solvable in the here and now. In many ways I am still wandering in the fog. But I have found cairns to follow, and they have guided many others in the midst of this crazy and unpredictable weather.")]), _c('p', {
    staticClass: "sep"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/sep_autre.jpg"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I have a friend who is a textile artist. Among other things, she sews nautical flags because, besides the fact that they’re gorgeous, there’s an accidental poetry to them. According to Merritt Tierce, “There are forty flags in a complete set of international maritime signal flags—one for each letter of the English alphabet, one for each number, and four flags called substitutes, which perform special operations.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-042",
      "id": "ap_ntf-042-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Raised by themselves or in different combinations, the flags mean different things. White with a blue cross, followed by a "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("flag divided into four colored triangles means "), _c('i', [_vm._v("What is the wind doing?")]), _vm._v(" Yellow and red triangles mean "), _c('i', [_vm._v("Man overboard")]), _vm._v(". There are combinations for races and to warn about gales. Tierce writes,")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("I wish we could fly such flags, we humans, ships unto ourselves, to communicate our states of balm or damage, our current headings, our desires and lacks. Maybe my friend’s radio has gone out, but at least he could fly his small I-am-suffering-on-this-sunny-day flag and I could raise my I-will-take-a-walk-with-you-and-listen flag. We could see each other, understand, and act, without having to say all the words."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-043",
      "id": "ap_ntf-043-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These days, with radio and digital communication, satellites and GPS, ships still keep flags on board in case all else fails, but they rarely use them. Flags on ships are a bit like oxygen masks on planes: they’re necessary when things go very badly wrong. If all you have left, drifting alone in the middle of the vast ocean, is a small square of flapping fabric calling for help, things are about as dire as they can be.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Now picture yourself in a boat, lost and afraid, adrift as the sun sets, with no way to contact anyone except for the flag you’ve been given for this very moment. You don’t know what else to do, so you raise the flag—bright white with a red X.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And you see a ship, distant but drawing nearer. It hoists flags in response, a bright red diamond on a white field, followed by another made of two triangles, yellow and red, and then lastly a white trapezoid marked with a red circle.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This is the flag combination that my friend sewed to hang on her bedroom wall. It means "), _c('i', [_vm._v("I will keep close to you during the night.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When I was drifting in grief, not knowing what else to do, the prayers of the church, especially the prayers of Compline, became my flag to fly in the night.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The hope God offers us is this: he will keep close to us, even in darkness, in doubt, in fear and vulnerability. He does not "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("promise to keep bad things from happening. He does not promise that night will not come, or that it will not be terrifying, or that we will immediately be tugged to shore.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("He promises that we will not be left alone. He will keep watch with us in the night.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Spufford writes that, ultimately, “we don’t ask for a creator who can explain himself. We ask for a friend in time of grief, a true judge in times of perplexity, a wider hope than we can manage in time of despair.” If we suffer deeply, he says, there is no explanation, no reason, no answer that can ease our heartbreak. “The only comfort that can do anything—and probably the most it can do is help you endure, or if you cannot endure to fail and fold without wholly hating yourself—is the comfort of feeling yourself loved.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-044",
      "id": "ap_ntf-044-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the end, that’s what I needed to know."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098def88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap3.vue
// module id = 81
// module chunks = 0